<template>
  <a-select v-model="selected" placeholder="MRD标题/ID" :filter-option="false" allow-clear show-search @search="onSearch">
    <a-spin v-if="loading" slot="notFoundContent" size="small" />
    <a-select-option v-for="(item, index) in dataSource" :key="index" :value="item.id">{{ `MR-${item.id} ${item.title}` }} </a-select-option>
  </a-select>
</template>

<script>
import { debounce } from 'lodash';
import { queryDocument } from '@/api/business/document';
export default {
  model: {
    prop: 'value',
    event: 'change'
  },
  props: {
    value: {
      type: [String, Number],
      default: undefined
    },
    unbound: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      loading: false,
      dataSource: [],
      filterForm: {
        title: null,
        pageSize: 20,
        pageNumber: 1
      }
    };
  },
  computed: {
    selected: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('change', val);
      }
    }
  },
  created() {
    if (this.method !== 'focus') {
      this.filterData();
    }
  },
  methods: {
    filterData() {
      this.loading = true;
      queryDocument({ ...this.filterForm, unbound: this.unbound })
        .then(res => {
          this.dataSource = res.data.items;
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    onSearch: debounce(function (value) {
      this.filterForm.keyword = value;
      this.filterData();
    }, 500)
  }
};
</script>
